import { render, staticRenderFns } from "./insertPayment.vue?vue&type=template&id=6efcb22c&scoped=true&"
import script from "./insertPayment.vue?vue&type=script&lang=js&"
export * from "./insertPayment.vue?vue&type=script&lang=js&"
import style0 from "./insertPayment.vue?vue&type=style&index=0&id=6efcb22c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6efcb22c",
  null
  
)

export default component.exports